module.exports = __webpack_public_path__ + "img/selected4-min.e6bd12ef.png";